(() => {
  const RESET_DELAY = 1800;
  const resetTimers = new WeakMap();
  const originalStates = new WeakMap();

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.product-conversion-promo [data-promo-copy]');
    if (!button) return;

    const code = button.dataset.copyCode;
    if (!code || !navigator.clipboard) return;

    const originalState = originalStates.get(button) || {
      label: button.textContent,
      ariaLabel: button.getAttribute('aria-label'),
    };
    originalStates.set(button, originalState);
    const pendingReset = resetTimers.get(button);
    if (pendingReset) window.clearTimeout(pendingReset);

    try {
      await navigator.clipboard.writeText(code);
      button.textContent = 'Copied';
      button.setAttribute('aria-label', 'Copied code');
      button.dataset.copyState = 'copied';
    } catch (error) {
      button.textContent = 'Unable to copy';
      button.setAttribute('aria-label', 'Unable to copy code');
      button.dataset.copyState = 'error';
    }

    const resetTimer = window.setTimeout(() => {
      button.textContent = originalState.label;
      if (originalState.ariaLabel) button.setAttribute('aria-label', originalState.ariaLabel);
      delete button.dataset.copyState;
      resetTimers.delete(button);
      originalStates.delete(button);
    }, RESET_DELAY);
    resetTimers.set(button, resetTimer);
  });
})();
